class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('[data-description-content]');
    this.toggleBtn = this.querySelector('[data-description-toggle]');
    this.labelMore = this.querySelector('[data-label-more]');
    this.labelLess = this.querySelector('[data-label-less]');
  }

  connectedCallback() {
    if (!this.content || !this.toggleBtn) return;

    this.content.classList.add('is-clamped');

    // Esperar a que el layout esté listo antes de medir
    requestAnimationFrame(() => {
      if (this.content.scrollHeight > this.content.clientHeight + 1) {
        this.toggleBtn.hidden = false;
      }
    });

    this.toggleBtn.addEventListener('click', this.onToggle.bind(this));
  }

  onToggle() {
    const expanded = this.content.classList.toggle('is-clamped');
    this.labelMore.hidden = !expanded;
    this.labelLess.hidden = expanded;
  }
}

customElements.define('product-description', ProductDescription);